export enum AnswerButtonType {
  DEFAULT = "default",
  SELECTED = "selected",
  CORRECT = "correct",
  INCORRECT = "incorrect",
}
